module.exports = __webpack_public_path__ + "static/media/me-4.2d94cf73.jpg";